module.exports = __webpack_public_path__ + "static/media/mssg_schedule_pt_BR.97f41837.png";